import types from "@/data/types"

// This is used to determine the request type for the scrape service
// It is used in the scrape/refresh.vue component
// It is used to determine the request type for the scrape service
// It is used in the scrape/refresh.vue component
const requestTypes = (type) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_WEB:
        case types.BALLPARK_APP:
        case types.BALLPARK_WEB:
        case types.PACIOLAN_SCRAPE:
        case types.SEATGEEK_SCRAPE:
            return "GENERATE_QR_ASYNC"
        case types.TM_AM_SCRAPE:
            return "TM_AM_SCRAPE"
        case types.SG:
            return "SEATGEEK_OFFICIAL_API"
        default:
            return null
    }
}

export default requestTypes
